<div class="modalbg" id="{{dialogId}}" style="display:grid">
  <div class="modal" [style.left.px]="offsetX" [style.top.px]="offsetY" [style.position]="position" [style.width]="width" [style.height]="height">
    <div class="modalhead" (mousedown)="onMouseDown($event)" >
      {{Title}}
      <span id="closeBtn"  (click)="closeN($event)" *ngIf="!isHeaderHidden">
                <img src="/assets/icons/close_white.svg"/>
            </span>
    </div>
    <div class="modalbody dialog-app-base-content" >
      <ng-content></ng-content>
    </div>
    <div class="modalfooter">
      <div><ng-content select="[leftFooterColumn]"></ng-content></div>
      <div class="footerbtns">
        <button class="btn_blue" (click)="submit()" *ngIf="!ExitButton">{{'Apply'|translate }}</button>
        <button (click)="close()" class="btn_lgray" *ngIf="!ExitButton">{{'Cancel'|translate }}</button>
        <button (click)="close()" class="btn_blue" *ngIf="ExitButton">{{'Exit'|translate }}</button>
      </div>
      <div><ng-content select="[rightFooterColumn]"></ng-content></div>
    </div>
  </div>
</div>
